import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import PageIsLoading from '../../components/PageIsLoading';
import { Box } from '@mui/material';
import { AccessToken } from 'common-models';
import SigninCallback from '../../components/Authentication/SigninCallback';

const CallbackPage: React.FC = () => {
    const auth = useAuth();
    console.debug(`CallbackPage: auth.user: ${auth.user}`);
    const [accessToken, setAccessToken] = useState<AccessToken | undefined>(undefined);

    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);


    useEffect(() => {
        console.debug(`settings: setting access token to ${auth.user?.access_token}`);
        setAccessToken(auth.user?.access_token ?? "")
        setIsAuthenticated(!!auth.user?.access_token);
    }, [auth.user])

    if (isAuthenticated && accessToken) {
        console.debug(`CallbackPage: rendering SigninCallback with accessToken: ${accessToken}`);
        return (
            <SigninCallback accessToken={accessToken} />
        )
    }

    console.debug(`CallbackPage: rendering PageIsLoading`);
    return (
        <Box>
            <PageIsLoading />
        </Box>
    )
};

export default CallbackPage;
